module.exports = __webpack_public_path__ + "static/media/baotree-logo.e09dbb0d.png";